import { getCountry } from '@iwIntlProvider/CountryProvider';
import { GetEarlyRepaymentSimulationResponse } from '@iwoca/lapi-client/edge';
import { Button } from '@iwoca/orion';
import { RootState } from '@iwProvider/configureStore';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { integerToStringNumberWithIntlGroups } from '../../../helpers/normalizers';
import IwMedia from '../../../iwMedia/index';
import { SHOW_REPAYMENT_SCHEDULE_MODAL } from '../../modals/repaymentScheduleModal/RepaymentScheduleModal.actions';
import DashboardLink from '../../navigation/DashboardLink';
import MainContentPending from '../../pageStructure/mainContentPending';
import { MainSectionWrapper } from '../../pageStructure/mainSectionWrapper';
import { TitleSectionWrapper } from '../../pageStructure/titleSectionWrapper/TitleSectionWrapper';
import PairItemContainer from '../../ui/pairItemContainer/PairItemContainer';
import {
    REQUEST_NEW_REPAYMENT_SCHEDULE_TO_REPAY,
    SHOW_CONFIRM_REPAYMENT_STEP,
    UPDATE_SELECTED_REPAYMENT_AMOUNT
} from '../EarlyRepayment.actions';
import styles from './ChooseRepaymentAmount.module.css';
import { RepaymentAmountBreakdown } from './repaymentAmountBreakdown/RepaymentAmountBreakdown';
import RepaymentSelectAmount from './repaymentSelectAmount/RepaymentSelectAmount';

const mapStateToProps = (state: RootState) => {
    const { intl, earlyRepayment } = state;
    return {
        ...intl,
        ...earlyRepayment,
        earlyRepaymentSimulationSchedule:
            state?.api?.early_repayment_simulation,
        initialValues: {
            amount: integerToStringNumberWithIntlGroups(
                earlyRepayment.selectedInputAmount!,
                intl.locale
            )
        }
    };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
    updateSelectedAmount: (inputAmount: number, sliderAmount: number) =>
        dispatch({
            type: UPDATE_SELECTED_REPAYMENT_AMOUNT,
            inputAmount,
            sliderAmount
        }),
    requestSelectedAmount: () =>
        dispatch({ type: REQUEST_NEW_REPAYMENT_SCHEDULE_TO_REPAY }),
    goToConfirm: () => dispatch({ type: SHOW_CONFIRM_REPAYMENT_STEP }),
    showSchedule: (customSchedule: GetEarlyRepaymentSimulationResponse) => {
        dispatch({
            type: SHOW_REPAYMENT_SCHEDULE_MODAL,
            customSchedule
        });
    }
});

type PropsFromRedux = ReturnType<typeof mapStateToProps> &
    ReturnType<typeof mapDispatchToProps>;

const ChooseRepaymentAmount = (props: PropsFromRedux) => {
    const { ready, goToConfirm } = props;

    if (ready) {
        return (
            <div className={styles.ChooseRepaymentAmount}>
                <IwMedia from="medium">
                    <TitleSectionWrapper>
                        <div className={styles.title}>
                            <FormattedMessage
                                id="_.early_repayment.choose_repayment_amount.title"
                                defaultMessage="How much would you like to repay?"
                            />
                        </div>
                        {getCountry() === 'DE' && (
                            <div className={styles.subTitle}>
                                <FormattedMessage
                                    id="_.early_repayment.choose_repayment_amount.sub_title"
                                    defaultMessage="-"
                                />
                            </div>
                        )}
                    </TitleSectionWrapper>
                </IwMedia>

                <MainSectionWrapper>
                    <PairItemContainer className={styles.repaymentSummary}>
                        <RepaymentSelectAmount {...props} />
                        <RepaymentAmountBreakdown {...props} />
                    </PairItemContainer>
                </MainSectionWrapper>

                <div className="fixed inset-x-0 bottom-0 z-10 bg-secondary-95">
                    <div className="mx-auto box-border flex w-full max-w-[60rem] flex-col px-[32px] py-l min-m:mt-0 min-m:flex-row min-m:justify-between min-m:p-xl">
                        <DashboardLink
                            variant="secondary"
                            className="mx-0 mb-xl h-[52px] min-m:mb-0"
                            size="large"
                        >
                            <FormattedMessage
                                id="_.early_repayment.choose_repayment_amount.back"
                                defaultMessage="← Return home"
                            />
                        </DashboardLink>

                        <Button onClick={goToConfirm} size="large">
                            <FormattedMessage
                                id="_.early_repayment.choose_repayment_amount.next"
                                defaultMessage="Next step →"
                            />
                        </Button>
                    </div>
                </div>
            </div>
        );
    }

    return <MainContentPending />;
};

// eslint-disable-next-line import/no-default-export
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ChooseRepaymentAmount);
